import React, { useEffect, useState } from 'react';
import { useNavigate   } from "react-router-dom";
import {SvgPC, SvgSairMenu, SvgEdit, SvgDelete, SvgNew2} from "../Svg.js"
import { Link } from 'react-router-dom'; 


function FormClienteGrid() {

    const [tabela, setTabela] = useState([]); // Estado para os dados da tabela
    const [currentPage, setCurrentPage] = useState(1); // Página atual
    const itemsPerPage = 12; // Número de itens por página
    
    const [delparagrafo,  setDelparagrafo] = useState(""); 
      const [PopExcluir, setPopExcluir] = useState(false); 
      const [itemToDelete, setItemToDelete] = useState(null); 
      const handleDeleteClick = (id) => {
        setDelparagrafo(`${id}`);
        setItemToDelete(id); 
        setPopExcluir(true);   };
      const confirmDelete = () => {

        console.log(`Excluindo item com id: ${itemToDelete}`);
        //alert(`Excluindo item com id: ${itemToDelete}`);
        setTabela((prevState) => prevState.filter((item) => item.id !== itemToDelete)); // Remove o item da tabela
        setPopExcluir(false);  
        handleDelete(itemToDelete);
      
      };
      const cancelDelete = () => {
        setPopExcluir(false); };

  //const [clientes, setClientes] = useState([]);
  const navigate = useNavigate(); // Inicialize o hook

  
  const handleDelete = async (id) => {
    //const userConfirmed = window.confirm("Você deseja Apagar o id:"+id+"?");
    //if (userConfirmed) {
    try {
      const response = await fetch(`http://www.criar.com.br:3000/clientedelete/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}), // Pode passar dados no corpo, se necessário
      });

      if (response.status === 200) {
        //const data = await response.text();
        //console.log(data);
        //alert(data);
        navigate(0);

      } else {
        console.error('Erro ao deletar cliente:', response.status);
        alert('Erro ao deletar cliente.'+response.status);
      }
  

    } catch (error) {
      console.error('Erro na requisição:', error);
      alert('Erro no servidor.', error);
    }
  //}
  }

  
  useEffect(() => {
       fetch('http://www.criar.com.br:3000/cliente')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Erro na resposta da API');
          }
          return response.json();
        })
        //.then((data) => setClientes(data.Cliente))
        .then((data) => {      setTabela(data.Cliente);  })

        .catch((error) => console.error('Erro ao buscar os dados:', error));
  } ); 
// Calcula os itens para a página atual
const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;
const currentItems = tabela.slice(startIndex, endIndex);

// Calcula o total de páginas
const totalPages = Math.ceil(tabela.length / itemsPerPage);

const handleNextPage = () => {
  if (currentPage < totalPages) {
    setCurrentPage((prevPage) => prevPage + 1);
  }
};

const handlePreviousPage = () => {
  if (currentPage > 1) {
    setCurrentPage((prevPage) => prevPage - 1);
  }
};



  return (
    
    <div id = "texto2"> 
      <table class="tableGrid">
        <thead>
          <tr>
            <th>Id</th>
            <th>Tipo</th>
            <th>Nome</th>
            <th>Data Até</th>
            <th>Situação</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {//clientes.map((cliente) => (
          currentItems.map((itens) => (
            <tr key={itens.Id}>
              <td>{itens.Id}</td>
              <td>{itens.Tipo}</td>
              <td>{itens.Nome}</td>
              <td>{DataParaGrid(itens.DataAte)}</td>
              <td>{itens.Situacao}</td>
              <td>&nbsp;  <Link to={`/FormCliente?id=${itens.Id}`}><SvgEdit/></Link>
              &nbsp;&nbsp;<Link to="#" onClick={() => handleDeleteClick(itens.Id)}><SvgDelete/></Link>
              &nbsp;&nbsp;<Link to={`/FormClienteEquipamentos?id=${itens.Id}`}><SvgPC/></Link>&nbsp;</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {PopExcluir && (
        <div className="modal">
          <div className="modal-content">
            <h3>Excluir</h3>
            <p>Tem certeza de que deseja excluir este item?</p>
            <p>{delparagrafo}</p>
            <button className="botaovermelho" onClick={confirmDelete}>Excluir</button>
            <button className="botaocinza" onClick={cancelDelete}>Cancelar</button>
          </div>
        </div>
      )}



      <p class = "texto5">
      <button class="botaocinsa"    onClick={() => {window.location.href = "./area"; }}><SvgSairMenu /><br/>Menu</button>&nbsp;
      <button class="botaocinsa"    onClick={() => {window.location.href = `FormClienteNovo`; }}><SvgNew2 /><br/>Incluir</button>&nbsp;

        <button  class = "botaocinsa" onClick={handlePreviousPage} disabled={currentPage === 1}>
        <br/><br/><br/>
        &laquo; 
        </button>
        &nbsp;  
        <button class = "botaocinsa" onClick={handleNextPage} disabled={currentPage === totalPages}>
        <br/><br/><br/>
           &raquo;
        </button>
        Página {currentPage} de {totalPages}
        </p>



    </div>
  );
}




function DataParaGrid(dataEntrada) {
  //alert(dataEntrada);
  const [month, day, year] = dataEntrada.split("/");
  const formattedDate = `${day}/${month}/${year}`;  
  return formattedDate; 
}

export default FormClienteGrid;